import { useState } from 'react';
import styled from './index.module.scss';
import Emarsys from '@/components/MembersDay/FY2024/Emarsys';

import getLocal from '@/app/utils/getLocal';
import gtm from '@/utils/gtm';
import { currentEmailSource } from '@/constants/membersday';
import { useLang } from '@/i18n';

export default function JPEmailBox() {
    const { t } = useLang('membersday.subscribe');
    const source = currentEmailSource;

    const successCallBack = () => {
        try {
            gtm.push({
                event: 'uaEvent',
                event_name: 'activity_submit',
                button_name: t('btnText'),
                status: 'success',
                tag: 'Agree',
            });
        } catch (e) {
            console.error(e);
        }
    };

    const errorCallback = () => {
        gtm.push({
            event: 'uaEvent',
            event_name: 'activity_submit',
            button_name: t('btnText'),
            status: 'fail',
            tag: 'Agree',
        });
    };

    return (
        <div className={styled.Subscribe}>
            <div className="email-box-jp">
                <Emarsys
                    source={source}
                    submitText={t('btnText')}
                    placeholder={t('placeholder')}
                    successCallback={successCallBack}
                    errorCallback={errorCallback}
                    checked={true}
                />
                <p className="protocol">
                    {t.rich('protocol', {
                        line1: (text: string) => (
                            <a className="link" href={'https://account.ecoflow.com/agreement/ja-jp/PrivacyPolicy.html'} target="_blank" rel="noreferrer">
                                {text}
                            </a>
                        ),
                        line2: (text: string) => (
                            <a className="link" href={'https://account.ecoflow.com/agreement/ja-jp/TermsOfUse.html'} target="_blank" rel="noreferrer">
                                {text}
                            </a>
                        ),
                    })}
                </p>
            </div>
        </div>
    );
}
